import { type TagParser } from './tagParser';
import { ParserRegistry } from './parserRegistry';

class DividerTagParser implements TagParser {
  tag = 'divider';

  parse() {
    return {
      html: '<hr class="my-1.5 h-px" />',
      consumedLength: 0,
    };
  }
}

ParserRegistry.register(new DividerTagParser());
